import React, { useEffect, useState } from 'react';

import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link, useParams } from 'react-router-dom';

import AscendingSvg from '../../components/Form/SortSvg/AscendingSvg';
import DescendingSvg from '../../components/Form/SortSvg/DescendingSvg';
import ProposalsFilter from '../../components/Filter/ProposalsFilter';

// import Pagination from '../../components/Pagination/ProposalPagination';
import { useDispatch, useSelector } from 'react-redux';
import { getApplicationList } from '../../redux/actions/applications/getApplicationList';
import UnProcessedFeedBackList from '../../components/FeedBacks/UnProcessedFeedBackList';
import { Pagination } from 'antd';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';
import { resetGetApplicationList } from '../../redux/slices/application.slice';
import SelectionFilter from '../../components/Filter/SelectionFilter';
import { statsApplications } from '../../redux/actions/applications/statsApplications';
import { getVacancySingle } from '../../redux/actions/dashborad/getVacancySingle';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function UnProcessedProposalsPage() {
  // const [activeTab, setActiveTab] = useState('unprocessed');
  const [currentPage, setCurrentPage] = useState(1);
  const { vacancyId } = useParams();
  const dispatch = useDispatch();
  const {
    getApplicationList: { data: getApplicationListData, error: getApplicationListError, loading: getApplicationListLoading },
    statsApplications: { data: statsApplicationsData, error: statsApplicationsError, loading: statsApplicationsLoading },
  } = useSelector((state) => state.application);

  const form = useForm({
    defaultValues: { sex: 'null', activeTab: 'unprocessed', userChecked: {} },
  });
  const activeTab = form.watch('activeTab');
  const formValue = form.watch();
  useEffect(() => {
    onFetchApplicationList(activeTab);
  }, [currentPage]);
  useEffect(() => {
    dispatch(statsApplications(vacancyId));
    dispatch(getVacancySingle(vacancyId));
    return () => {
      dispatch(resetGetApplicationList());
    };
  }, []);
  const onFetchApplicationList = (status, filter) => {
    dispatch(
      getApplicationList({
        vacancy_id: vacancyId,
        ...getFormatFilter(filter ? filter : formValue),
        page: currentPage,
        is_processed: status != 'unprocessed',
        // status: status == 'unprocessed' ? 'created' : 'processed',
      }),
    );
  };
  const getFormatFilter = (data) => {
    let filter = {};
    if (data.age_from && parseInt(data.age_from)) {
      filter = { ...filter, age_from: parseInt(data.age_from) };
    }
    if (data.age_to && parseInt(data.age_to)) {
      filter = { ...filter, age_to: parseInt(data.age_to) };
    }
    if (data.has_avatar) {
      filter = { ...filter, has_avatar: true };
    }
    if (data.full_name) {
      filter = { ...filter, full_name: data.full_name };
    }
    if (data.sex == 'true' || data.sex == 'false') {
      filter = { ...filter, sex: data.sex == 'true' ? true : false };
    }

    return filter;
  };
  React.useEffect(() => {
    const subscription = form.watch((value, { name, type }) => {
      console.log(name);

      if (name !== 'userChecked') {
        if (currentPage == 1) {
          onFetchApplicationList(value?.activeTab, value);
        } else {
          setCurrentPage(1);
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [form.watch, currentPage]);

  return (
    <div className="mx-auto flex flex-1 flex-col w-full max-w-[1163px]">
      <div className="w-full mt-9">
        <div className="flex justify-between gap-1">
          <p className="text-2xl font-medium px-2">Отклики</p>
          {/* <p className='flex flex-wrap justify-center items-center'>
                        <button
                            type='button'
                            className='text-center border rounded py-2 px-2  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300'
                        >
                            Очистить выбор
                        </button>
                    </p> */}
        </div>
      </div>
      <div className="w-full flex flex-col md:flex-row justify-between gap-4">
        <div className="flex flex-col w-full md:w-3/4 gap-y-3 p-2 ">
          <div className="flex flex-col md:flex-row justify-between md:items-center px-2 mt-2 gap-y-4">
            <div className="flex flex-row gap-x-3 items-center">
              <Link
                onClick={() => {
                  form.setValue('activeTab', 'unprocessed');
                }}
                className={clsx(activeTab == 'unprocessed' ? 'font-bold' : 'underline')}>
                Необработанные {statsApplicationsData && `(${statsApplicationsData?.unprocessed})`}
              </Link>
              <Link
                onClick={() => {
                  form.setValue('activeTab', 'processed');
                }}
                className={clsx(activeTab == 'processed' ? 'font-bold' : 'underline')}>
                Обработанные {statsApplicationsData && `(${statsApplicationsData?.processed})`}
              </Link>
            </div>
          </div>
          <div className="flex flex-col pb-[64px]">
            <UnProcessedFeedBackList
              vacancyId={vacancyId}
              activeTab={activeTab}
              form={form}
              currentItems={getApplicationListData?.results}
              onFetch={() => {
                if (currentPage == 1) {
                  onFetchApplicationList(activeTab);
                } else {
                  setCurrentPage(1);
                }
                dispatch(statsApplications(vacancyId));
              }}
            />
            {getApplicationListData?.results?.length ? (
              <Pagination
                defaultCurrent={currentPage}
                total={getApplicationListData?.count}
                showSizeChanger={false}
                current={currentPage}
                disabled={getApplicationListLoading}
                onChange={(e) => {
                  setCurrentPage(e);
                }}
              />
            ) : (
              <></>
            )}

            {/* {type === 'unprocessed' || type === undefined ?  : <ProcessedFeedBackList currentItems={currentItems} />} */}
            {/* <Pagination type={`unprocessed`} itemsPerPage={10} sortType={sortType} sortDirection={sortDirection} /> */}
          </div>
        </div>
        <div className="flex flex-col w-full md:w-1/4 px-2">
          <SelectionFilter form={form} isFeedback />
          {/* <ProposalsFilter /> */}
        </div>
      </div>
    </div>
  );
}

export default UnProcessedProposalsPage;
